import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/vcicon.svg'
import _imports_1 from '@/assets/icons/download.svg'
import _imports_2 from '@/assets/icons/addonicon.svg'


const _hoisted_1 = { class: "viewopts" }
const _hoisted_2 = { class: "prodiv font-regular-18" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"48px","margin-right":"20px"}
}, null, -1)
const _hoisted_4 = { style: {"text-align":"start"} }
const _hoisted_5 = { style: {"margin":"unset"} }
const _hoisted_6 = { class: "font-bold-18" }
const _hoisted_7 = { class: "subdiv" }
const _hoisted_8 = {
  class: "font-bold-18",
  style: {"margin":"unset"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "font-regular-14 marginright" }, "Version:", -1)
const _hoisted_10 = { class: "subdiv" }
const _hoisted_11 = {
  class: "font-bold-18",
  style: {"margin":"unset"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "font-regular-14 marginright" }, "Product Seats:", -1)
const _hoisted_13 = { class: "userprodiv" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"24px","margin-left":"5px"},
  alt: "downloadimg",
  title: "downloadimg"
}, null, -1)
const _hoisted_15 = { class: "addonnamediv" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"width":"25px","margin-right":"20px"},
  alt: "addonimg",
  title: "addonimg"
}, null, -1)
const _hoisted_17 = { style: {"text-align":"start"} }
const _hoisted_18 = {
  class: "font-bold-14",
  style: {"margin":"unset"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "subdiv" }, null, -1)
const _hoisted_20 = { class: "subdiv marginright" }
const _hoisted_21 = {
  class: "font-bold-16",
  style: {"margin":"unset"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "font-regular-14 marginright" }, "Add-on Seats:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.dataof.productName.substring(0, 18)), 1),
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.dataof.productName.substring(18)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.dataof.majorVersionNumber) + "." + _toDisplayString(_ctx.dataof.minorVersionNumber), 1),
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.dataof.seatsUsed) + "/" + _toDisplayString(_ctx.dataof.seats), 1),
        _hoisted_12
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_el_link, {
          id: "downloadlink",
          class: "downloadbtn",
          underline: "never",
          href: _ctx.dataof.installer,
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Download "),
            _hoisted_14
          ]),
          _: 1
        }, 8, ["href"])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addoninfo, (addon, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "addonviewopts"
      }, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, _toDisplayString(addon.productName), 1)
          ])
        ]),
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("h5", _hoisted_21, _toDisplayString(addon.seatsUsed) + "/" + _toDisplayString(addon.seats), 1),
          _hoisted_22
        ])
      ]))
    }), 128))
  ], 64))
}